import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { ComponentType, createElement, ElementType } from 'react';

import { SPACING_UNIT } from '../../constant/spacing';

interface Props {
  icon: ComponentType<RequiredIconProps>;
  component?: ElementType;
  target?: string;
  rel?: string;
}

interface RequiredIconProps {
  className?: string;
}

const ButtonWithIcon = ({ icon, component, target, rel, children, ...props }: ButtonProps & Props) => {
  const Icon = BaseIcon.withComponent(icon);

  return (
    <Root {...(props as any)} component={component} target={target} rel={rel}>
      <Icon />

      {children}
    </Root>
  );
};

export const Root = styled(Button)({ paddingLeft: SPACING_UNIT });

const BaseIcon = styled('svg')({
  height: 20,
  marginRight: SPACING_UNIT / 2,
});

export default ButtonWithIcon;
